'use strict'
import axios from 'axios'

let config = {
	baseURL:
		'https://us-central1-mercurio-vm-servers.cloudfunctions.net/instagram-media',
	timeout: 100000,
}

const _instagram = axios.create(config)

_instagram.interceptors.request.use(
	config => {
		return config
	},
	function(error) {
		return Promise.reject(error.response)
	},
)

// Add a response interceptor
_instagram.interceptors.response.use(
	function(response) {
		if (response.data) {
			return response.data
		} else {
			return response
		}
	},
	function(error) {
		return Promise.reject(error.response)
	},
)

export default _instagram
